import React, { useEffect } from 'react';
import { Form, Input, Card, Row, Col, Button } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { notEmptyRule } from './validationUtils';
import ImageDisplayField from '../ImageDisplayField';

const { TextArea } = Input;

const FindUsSection = ({ 
  sectionKey, 
  sectionData, 
  uploadingImage, 
  uploadProps, 
  handleImageUploadForSliderImage,
  currentLanguage,
  form
}) => {
  const { t } = useTranslation();
  
  // Create dynamic field names based on current language
  const langKey = currentLanguage.toLowerCase();
  const getFieldName = (field) => ['content', langKey, sectionKey, field];

  // Define default structure for slider images
  const defaultSliderImage = {
    image: ''
  };

  useEffect(() => {
    const sliderImagesFieldName = getFieldName('slider_images');
    const currentSliderImages = form.getFieldValue(sliderImagesFieldName) || [];
    
    if (currentSliderImages.length === 0) {
      form.setFieldsValue({
        [sliderImagesFieldName.join('.')]: [defaultSliderImage]
      });
    }
  }, []);

  return (
    <>
      {/* Regular section fields */}
      {sectionData.title !== undefined && (
        <Form.Item
          name={getFieldName('title')}
          label={t('Titolo')}
          rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
        >
          <Input placeholder={t('Inserisci il titolo')} />
        </Form.Item>
      )}

      {sectionData.description !== undefined && (
        <Form.Item
          name={getFieldName('description')}
          label={t('Descrizione')}
          rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
        >
          <TextArea rows={3} placeholder={t('Inserisci la descrizione')} />
        </Form.Item>
      )}

      {sectionData.button !== undefined && (
        <Form.Item
          name={getFieldName('button')}
          label={t('Testo del pulsante')}
          rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
        >
          <Input placeholder={t('Inserisci il testo del pulsante')} />
        </Form.Item>
      )}

      {/* Slider images section */}
      <Form.Item
        name={getFieldName('slider_images')}
        label={t('Immagini slider')}
      >
        <Form.List name={getFieldName('slider_images')}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Card
                  key={key}
                  size='small'
                  style={{ marginBottom: 16 }}
                  extra={
                    fields.length > 1 && (
                      <Button
                        type='text'
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => remove(name)}
                        size='small'
                      >
                        {t('Rimuovi')}
                      </Button>
                    )
                  }
                >
                  <Form.Item
                    {...restField}
                    name={[name, 'image']}
                    label={t('Immagine slider')}
                    rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
                  >
                    <ImageDisplayField
                      name={[...getFieldName('slider_images'), name, 'image']}
                      label={t('Immagine slider')}
                      uploadingImage={uploadingImage}
                      uploadProps={uploadProps}
                      onUpload={(file) => handleImageUploadForSliderImage(file, sectionKey, name)}
                      onRemove={() => {
                        const currentValues = form.getFieldsValue();
                        const fieldPath = ['content', currentLanguage.toLowerCase(), sectionKey, 'slider_images', name, 'image'];
                        let current = currentValues;
                        for (let i = 0; i < fieldPath.length - 1; i++) {
                          if (!current[fieldPath[i]]) {
                            current[fieldPath[i]] = {};
                          }
                          current = current[fieldPath[i]];
                        }
                        current[fieldPath[fieldPath.length - 1]] = '';
                        form.setFieldsValue(currentValues);
                      }}
                    />
                  </Form.Item>
                </Card>
              ))}
              <Button
                type='dashed'
                icon={<PlusOutlined />}
                onClick={() => add({ ...defaultSliderImage })}
                style={{ width: '100%' }}
              >
                {t('Aggiungi immagine slider')}
              </Button>
            </>
          )}
        </Form.List>
      </Form.Item>
    </>
  );
};

export default FindUsSection; 